// Case study content, facts as stated by the owner.
export const CASE_STUDIES = {
  "param-dairy-branding": {
    slug: "param-dairy-branding",
    tag: "Case Study · Branding & Exhibitions",
    client: "Param Dairy",
    title: "One exhibition. Complete branding. 59 B2B leads.",
    hero: `${process.env.PUBLIC_URL}/assets/final-impact-of-exhibition.png`,
    heroAlt: "Param Dairy exhibition environment designed by The Next Design",
    intro:
      "Param Dairy was stepping onto the Indusfood stage, one of India's biggest food-trade exhibitions. The products were proven. The brand presence had to prove them at first glance.",
    challengeTitle: "The Challenge",
    challenge:
      "Trade exhibitions are expensive shelf space. Hundreds of exhibitors compete for the same buyers walking the same aisles, and a stall that blends in quietly burns the budget. Param Dairy needed a complete brand presence, stall, invites, digital, that made buyers stop, and gave the sales team a story worth stopping for.",
    didTitle: "What We Did",
    didIntro:
      "The Next Design delivered the complete branding for the exhibition, designed as one continuous brand experience, from the first invite a buyer received to the stall they walked into.",
    did: [
      {
        title: "Exhibition Design",
        text: "A brand environment engineered to be seen across the hall, and to hold a business conversation once it pulled buyers in.",
        image: `${process.env.PUBLIC_URL}/assets/exhibition-design.jpg`,
      },
      {
        title: "Invite Design",
        text: "Pre-show communication that put Param Dairy on buyers' must-visit list before the exhibition doors opened.",
        image: `${process.env.PUBLIC_URL}/assets/invite-design.jpg`,
      },
      {
        title: "Website Design",
        text: "The digital destination every invite and stall conversation pointed to, consistent with the exhibition experience.",
        image: `${process.env.PUBLIC_URL}/assets/web.jpg`,
      },
    ],
    outcomeStat: "59",
    outcomeLabel: "B2B leads from the Indusfood exhibition",
    outcomeText:
      "The complete branding programme turned one exhibition appearance into 59 B2B leads, proof that when the brand environment matches the product quality, buyers respond.",
  },
  "vpv-kesaria-rubber": {
    slug: "vpv-kesaria-rubber",
    tag: "Case Study · Virtual Plant Visit",
    client: "Kesaria Rubber Industries Pvt. Ltd.",
    title: "When buyers won't travel, bring the plant to them.",
    video: "https://www.youtube.com/embed/62asCfqRRbw?start=64",
    intro:
      "Kesaria Rubber Industries had the kind of factory that wins export business, if buyers could see it. That was exactly the problem.",
    challengeTitle: "The Challenge",
    challenge:
      "Kesaria's biggest credibility asset was its plant. But getting overseas and outstation buyers to actually visit was the bottleneck, visits are slow to schedule, expensive to host, and too many conversations stalled before a buyer ever saw the factory floor.",
    didTitle: "The Intervention",
    didIntro:
      "The Next Design built a Virtual Plant Visit (VPV) for Kesaria Rubber, an interactive walk through the real plant that any buyer, anywhere, can take on their own time. The factory's scale, process discipline and infrastructure became available on demand.",
    did: [],
    outcomeStat: "80%+",
    outcomeLabel: "lead conversion after the VPV, as stated by Kesaria's export head",
    outcomeText:
      "With the plant open to every serious buyer, Kesaria Rubber's lead conversion moved above 80%, as stated by their export head. The VPV removed the visit bottleneck and let the factory do what it was always capable of, convincing buyers.",
  },
};
